export enum CloudProviderState {
    PingOne = 'PINGONE',
    Okta = 'OKTA',
    Azure = 'AZURE',
    JumpCloud = 'JUMPCLOUD',
  }